import React from 'react'

const Header = () => {
  return (
    <div id="box1" class="brown">
            <div id="box11">
                <div id="box111">
                    <img src="logo.png" alt="logo"/>
                </div>
                <div id="box112">
                    <span class="h1">SARKARI RESULT</span><br/>
                    <span class="h3">WWW.SARKARIRESULT.COM</span>
                </div>
            </div>
            <nav id="box12">
                <span class="b1">Home</span>
                <span class="b1">Latest Jobs</span>
                <span class="b1">Results</span>
                <span class="b1">Admit Card</span>
                <span class="b1">Answer Key</span>
                <span class="b1">Syllabus</span>
                <span class="b1">Admission</span>
                <span class="b1 b2">Contact Us</span>
            </nav>
        </div>
  )
}

export default Header
